import { useEffect, useState } from "react";

export const useSquareIcon = (src, size = 96) => {
  const [icon, setIcon] = useState(src);
  useEffect(() => {
    if (!src) return;
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext("2d");
        if (!ctx) return;
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, size, size);
        const scale = Math.min(size / img.width, size / img.height);
        const w = img.width * scale;
        const h = img.height * scale;
        const x = (size - w) / 2;
        const y = (size - h) / 2;
        ctx.drawImage(img, x, y, w, h);
        setIcon(canvas.toDataURL("image/png"));
      } catch (_) {}
    };
    img.src = src;
  }, [src, size]);
  return icon;
};

export const isFullName = (value) => {
  const parts = String(value || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  return parts.length >= 2;
};

export const parseTimeValue = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return null;
  const match = raw.match(/^(\d{1,2}):(\d{2})$/);
  if (!match) return null;
  const h = Number(match[1]);
  const m = Number(match[2]);
  if (!Number.isFinite(h) || !Number.isFinite(m)) return null;
  if (h < 0 || h > 23 || m < 0 || m > 59) return null;
  const hh = String(h).padStart(2, "0");
  const mm = String(m).padStart(2, "0");
  return `${hh}:${mm}`;
};


export const loadImage = (src) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });

export const dataUrlToBlob = (dataUrl) => {
  try {
    const [meta, content] = String(dataUrl || "").split(",");
    if (!meta || !content) return null;
    const mime = meta.match(/data:(.*);base64/);
    const byteString = atob(content);
    const len = byteString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i += 1) bytes[i] = byteString.charCodeAt(i);
    return new Blob([bytes], { type: mime ? mime[1] : "image/png" });
  } catch (_) {
    return null;
  }
};

export const drawRoundedRect = (ctx, x, y, w, h, r) => {
  const radius = Math.min(r, w / 2, h / 2);
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.arcTo(x + w, y, x + w, y + h, radius);
  ctx.arcTo(x + w, y + h, x, y + h, radius);
  ctx.arcTo(x, y + h, x, y, radius);
  ctx.arcTo(x, y, x + w, y, radius);
  ctx.closePath();
};

export const fitText = (ctx, text, maxWidth, baseFont, minSize = 18) => {
  const match = String(baseFont).match(/(\d+)px/);
  const baseSize = match ? Number(match[1]) : 28;
  let size = baseSize;
  let font = baseFont.replace(/\d+px/, `${size}px`);
  ctx.font = font;
  while (size > minSize && ctx.measureText(text).width > maxWidth) {
    size -= 2;
    font = baseFont.replace(/\d+px/, `${size}px`);
    ctx.font = font;
  }
  return font;
};

export const wrapTextLines = (ctx, text, maxWidth) => {
  const words = String(text || "").trim().split(/\s+/).filter(Boolean);
  if (!words.length) return [""];
  const lines = [];
  let line = "";
  words.forEach((word) => {
    const test = line ? `${line} ${word}` : word;
    if (ctx.measureText(test).width <= maxWidth) {
      line = test;
    } else {
      if (line) lines.push(line);
      line = word;
    }
  });
  if (line) lines.push(line);
  return lines;
};
